import React from "react";
import { IntlProvider } from "react-intl";
import AppFooter from "./components/presentational/AppFooter/AppFooter";
import AppHeader from "./components/presentational/AppHeader/AppHeader";
const INTL_FORMATS = {
    number: {
        usd: {
            style: "currency",
            currency: "USD"
        }
    }
};
export function getAccessibilityAttrs(props) {
    const accessibilityAttrs = {};
    if (props.isActiveModal) {
        accessibilityAttrs["aria-hidden"] = true;
    }
    return accessibilityAttrs;
}
const AppView = (props) => {
    const accessibilityAttrs = getAccessibilityAttrs(props);
    return (<IntlProvider key={`${props.locale}:${props.messages == null}`} locale={props.locale === "es" ? "es-US" : props.locale} messages={props.messages} formats={INTL_FORMATS} defaultFormats={INTL_FORMATS}>
			<div className="site">
				{props.skipLink}
				{props.modals}
				<div className="site-hd" {...accessibilityAttrs}>
					<AppHeader display={props.isLoggedIn} logout={props.logout} lastLogin={props.lastLogin}/>
				</div>
				<div className="site-bd" {...accessibilityAttrs}>
					<main className="content content_buffer" role="main">
						<div className="js-mainContainer" tabIndex={-1}/>
						<div>
							{props.children}
						</div>
					</main>
				</div>
				<div className="site-ft" {...accessibilityAttrs}>
					<AppFooter locale={props.locale} selectLocale={props.selectLocale} loggedIn={props.isLoggedIn}/>
				</div>
			</div>
		</IntlProvider>);
};
export default AppView;



// WEBPACK FOOTER //
// ./src/assets/scripts/AppView.tsx